/**
 * @fileoverview GET handler for the "/apps/:app_group_id/user_imports/:import_id/search_event_catalog" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsImportIdSearchEventCatalog } from "./constants";
import type {
  GetAppsAppGroupIdUserImportsImportIdSearchEventCatalogProps,
  GetAppsAppGroupIdUserImportsImportIdSearchEventCatalogResult,
} from "./types";
import { isGetAppsAppGroupIdUserImportsImportIdSearchEventCatalogResult } from "./validators";

/**
 * The catalog endpoints answer with typed `UserEncodedError`s (`CSV_IMPORT_NOT_FOUND`,
 * `EVENT_CATALOG_REQUIRES_EVENTS_IMPORT`, `DATA_MAPPER_STORAGE_ERROR`) that the mapper renders as
 * its own copy, so a failed search must not raise the root error boundary's modal.
 */
const DATA_MAPPER_FETCH_SETTINGS = {
  propagateFetchRequestError: false,
};

export const getAppsAppGroupIdUserImportsImportIdSearchEventCatalog = reactQueryFetcherAdapter(
  appsAppGroupIdUserImportsImportIdSearchEventCatalog,
  (
    signal: AbortSignal,
    { appGroupId, importId, query }: GetAppsAppGroupIdUserImportsImportIdSearchEventCatalogProps
  ): Promise<GetAppsAppGroupIdUserImportsImportIdSearchEventCatalogResult> => {
    const queryParams: Record<string, string> = {};
    if (query !== "") {
      queryParams.query = query;
    }

    return fetch<GetAppsAppGroupIdUserImportsImportIdSearchEventCatalogResult>(
      `/apps/${appGroupId}/user_imports/${importId}/search_event_catalog`,
      "GET",
      queryParams,
      { signal },
      DATA_MAPPER_FETCH_SETTINGS
    );
  },
  isGetAppsAppGroupIdUserImportsImportIdSearchEventCatalogResult
);
